<template>
  <v-card class="w-100 pa-5 pr-16" dir="ltr">
    <v-row>
      <v-col cols="2">
        <div class="flex-row-start-center gap-5">
          <div
            class="mainTable icon-box flex-row-center-center"
            @click="open = !open"
          >
            <v-icon color="text">
              {{ open ? "mdi-chevron-up" : "mdi-chevron-down" }}
            </v-icon>
          </div>
          <div class="text-body-2 text--text">Inputs:</div>
        </div>
      </v-col>
      <v-col cols="3" v-for="(value, key) in inputData" :key="key">
        <div class="flex-row-start-center text-body-2">
          <span class="mainBlue--text mr-1">
            {{
              key === "targetCarbon"
                ? "Carbon"
                : key === "targetMetal"
                ? "Metallization"
                : $t(key)
            }}:
          </span>
          <span>{{ value }} %</span>
        </div>
      </v-col>
      <v-col cols="4" dir="rtl">
        <div class="flex-row-start-center gap-2">
          <div class="text-body-2 text--text">{{ $t("dateTime") }}:</div>
          <div class="text-body-2 text--text">
            {{ time }}
          </div>
        </div>
      </v-col>

      <v-col cols="12" v-if="open" class="pl-16">
        <v-row>
          <v-col cols="12">
            <div class="text-body-2 text--text">Outputs:</div>
          </v-col>
          <v-col cols="12">
            <div class="text-body-2 font-weight-medium text--text ml-2">
              Recommended Parameters:
            </div>
          </v-col>
          <v-col
            cols="4"
            v-for="param in recommendationData.parameters"
            :key="param.name"
          >
            <div class="flex-row-start-center gap-2 ml-2">
              <div class="text-body-2 mainBlue--text">{{ param.name }}:</div>
              <div class="text-body-2 text--text">{{ param.value }}</div>
            </div>
          </v-col>
          <v-col cols="12" class="mt-2">
            <div class="text-body-2 font-weight-medium text--text ml-2">
              Recommended Result:
            </div>
          </v-col>
          <v-col cols="4" v-for="data in outputData" :key="data">
            <div class="flex-row-start-center gap-2 ml-2">
              <div class="text-body-2 mainBlue--text">{{ $t(data) }}:</div>
              <div class="text-body-2 text--text">
                {{ recommendationData[data] }} %
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import moment from "jalali-moment";

export default {
  name: "RecommendationHistoryCard",

  props: {
    recommendationData: { type: Object, required: true },
  },

  data() {
    return {
      open: false,
      outputData: ["carbon", "metallization"],
    };
  },

  computed: {
    inputData() {
      return {
        targetCarbon: this.recommendationData.targetCarbon,
        targetMetal: this.recommendationData.targetMetal,
      };
    },
    time() {
      return moment(this.recommendationData.time).format(
        "jDD jMMMM jYYYY - hh:mm"
      );
    },
    groupedParameters() {
      const params = this.recommendationData.parameters || [];
      const groups = [];
      for (let i = 0; i < params.length; i += 3) {
        groups.push(params.slice(i, i + 3));
      }
      return groups;
    },
  },
};
</script>

<style scoped>
.icon-box {
  border-radius: 4px;
  width: 24px;
  height: 24px;
  cursor: pointer;
}
</style>
